import type { HelpFile } from '../../types/help'
import { TypeValueDetailTestIds } from '../../../testids/TypeValueDetailTestIds'

export const typeValueDetailHelp: HelpFile = {
  docPage: '/docs/admin/types',
  texts: {
    [TypeValueDetailTestIds.typeValueDetailPage]:
      'Detail page of a single type value — manage settings, translations, and scoped attributes.',
    [TypeValueDetailTestIds.typeValueDetail]: null,
    [TypeValueDetailTestIds.scopedAttributes]:
      'Attribute definitions scoped to this type value — only entities of this type can carry them.',
    [TypeValueDetailTestIds.cardTitleSettings]:
      'Core settings for this type value, including the display name template and active state.',
    [TypeValueDetailTestIds.cardTitleScopedAttributes]:
      'Attribute definitions scoped to this type value — only entities of this type can use them.',
    [TypeValueDetailTestIds.cardTitleTranslations]:
      'Localized labels and descriptions for this type value across supported languages.',
    [TypeValueDetailTestIds.inputTemplate]:
      'Display name template — Mustache-style placeholders such as {{firstName}} {{lastName}} are resolved against entity attributes when the type value is rendered.',
    [TypeValueDetailTestIds.btnSaveSettings]: null,
    [TypeValueDetailTestIds.btnEditTranslations]: null,
    [TypeValueDetailTestIds.stalePlaceholderWarning]:
      'Warning that the template references attribute placeholders that no longer exist on the underlying type.',
    [TypeValueDetailTestIds.colLanguage]: null,
    [TypeValueDetailTestIds.colLabel]: null,
    [TypeValueDetailTestIds.colDescription]: null,
    [TypeValueDetailTestIds.colLanguageEdit]: null,
    [TypeValueDetailTestIds.colLabelEdit]: null,
    [TypeValueDetailTestIds.colDescriptionEdit]: null,
  },
}
